import {  useState } from 'react';

import { Link } from 'react-router-dom';
import { getAuth, signOut } from "firebase/auth";
import useAuth from '../context/hook/useAuth';

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'

import site from "../utils/SiteSettings"
import "./header.css"


export const Header = () => {
  
    const {dispatch,user} = useAuth()

    // eslint-disable-next-line
    const [isLoading, setIsLoading] = useState(false)

    const userSignOut = getAuth();

    const hanldeClick = async (e) => {
        // e.preventDefault();

        try {
            
            signOut(userSignOut).then(() => {
                localStorage.removeItem("cthash")
                dispatch({
                    type: "LOGOUT",
                })
                setTimeout(()=>{
                    //this is used to redirect to login after the registered in successfully
                    // window.location.href="/login"
                    window.location.href="/login"
                },2000)
                toast.success("Sign-out successful",{position:'top-right'})
            // Sign-out successful.
            }).catch((error) => {
                console.log(error)
            // An error happened.
            }); 
        } catch (error) {
            console.log(error)
        }
    }

   const handleSideBar = async () => {
    try {
        // setIsLoading(true)
        var nasd = document.getElementById("primaryMenu")
        // console.log(nasd.classList)
        nasd.classList.remove("show")
        var class1 = document.getElementsByClassName("offcanvas-backdrop fade")
        // console.log(class1.classList)
        // console.log(class1[0])
        class1[0].classList.remove("show","offcanvas-backdrop","fade")
        // console.log()
    } catch (error) {
        console.log(error)
    }
   }
  return (
    <>
        <header>
        {/* <div id="recaptcha-container"></div> */}
            <button className="navbar-toggler d-xl-none d-inline navbar-menu-button" type="button" data-bs-toggle="offcanvas" data-bs-target="#primaryMenu">
                <span className="navbar-toggler-icon">
                <i className="fa-solid fa-bars"></i>
                </span>
            </button>
            <Link to={"/"} className="logo-text">
                <img  src={require("../../assets/logo.png")} className="img-fluid logo-size" alt="robot" />
            </Link>
            <nav className="header-nav-middle">
                <div className="main-nav navbar navbar-expand-xl navbar-light navbar-sticky">
                    {/* <div className={ `offcanvas-collapse order-xl-2 ${isLoading === false ? "" : "show"}`}  id="primaryMenu"> */}
                    <div className="offcanvas offcanvas-collapse order-xl-2" id="primaryMenu">
                        <div className="offcanvas-header navbar-shadow">
                            <h5 className="mb-0 vis-hidden">Back</h5>
                            <button className="btn-close lead" type="button" data-bs-dismiss="offcanvas"
                                aria-label="Close"></button>
                        </div>
                        <div className='topnav'>
                            <div className= "offcanvas-body">
                                <ul className="navbar-nav">
                                    <li className="nav-item ">
                                        <Link  className="nav-link" to={"/buy/token"}>Buy {site?.site?.siteName}</Link>
                                    </li>
                                    <li className="nav-item" >
                                        {/* <a  className="nav-link " href="#about" */}
                                        {/* // <a onClick={handleSideBar} className={isLoading === true ? "nav-link" : "offcanvas offcanvas-collapse order-xl-2"} href="#about" data-bs-dismiss="offcanvas" */}
                                        <a onClick={handleSideBar} className="nav-link" href="#about">About Us</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" onClick={handleSideBar} href="#token">Tokenomics</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link" onClick={handleSideBar} href="#feature">Features</a>
                                    </li>
                                    <li className="nav-item">
                                        <Link className="nav-link" onClick={handleSideBar} to={"/wallet"}>Wallet</Link>
                                    </li>
                                    <li className="nav-item w-none">
                                    {
                                        user ? (
                                            <Link data-cursor="pointer" to={''}  onClick={hanldeClick} className="nav-link">
                                                <span>
                                                    Logout
                                                </span>
                                            </Link>
                                            
                                        ):(
                                            <Link data-cursor="pointer" to={'/login'} className="nav-link">
                                                <span>
                                                    Login Now
                                                </span>
                                            </Link>
                                        )
                                    }
                                    </li>
                                    {/* <li className="nav-item">
                                        <a className="nav-link" href="#FaQ">FAQ</a>
                                    </li> */}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            {
                user ? (
                    <Link data-cursor="pointer" to={''}  onClick={hanldeClick} className="btn-solid d-sm-inline-block d-none"><span>Logout
                    </span></Link>
                    
                ):(
                    <Link data-cursor="pointer" to={'/login'} className="btn-solid d-sm-inline-block d-none"><span>Login
                    Now</span></Link>
                )
            }
        </header>
    </>
  )
}
